// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1bh5k","calendarButtons":"ClockData_calendarButtons__1vJH0"};